import React, {createContext, useContext} from 'react';
import {FormikProvider, useFormik} from 'formik';
import * as actions from '../_redux/transfersByAgentActions';

const FindAgentContext = createContext({});

export const useFindAgentContext = () => useContext(FindAgentContext);

export const FindAgentProvider = ({children}) => {
  const findAgents = (text) => {
    return actions.findAgents(text);
  };

  const formik = useFormik({
    initialValues: {agentID: ''},
    onSubmit: () => {
    },
    enableReinitialize: true
  });

  return (
    <FindAgentContext.Provider value={{formik, findAgents}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </FindAgentContext.Provider>
  );
};